import { Ref, ref } from '@vue/composition-api';

export interface RefreshPageStore {
	init(): void;
	refreshApp(): void;
	doesUpdateExist: Ref<boolean>;
}

export const getRefreshPageStore = (): RefreshPageStore => {
	const isRefreshing = ref(false);
	const doesUpdateExist = ref(false);
	const registration: Ref<null | ServiceWorkerRegistration> = ref(null);

	const init = () => {
		document.addEventListener('swUpdated', (e: Event) => {
			if ('detail' in e) {
				registration.value = (e as CustomEvent).detail;
				doesUpdateExist.value = true;
			}
		}, { once: true });
		if (navigator.serviceWorker) {
			navigator.serviceWorker.addEventListener('controllerchange', () => {
				if (isRefreshing.value) return;
				isRefreshing.value = true;
				window.location.reload();
			});
		}
	};

	const refreshApp = () => {
		doesUpdateExist.value = false;
		if (!registration.value || !registration.value.waiting) {
			return;
		}
		registration.value.waiting.postMessage({ type: 'SKIP_WAITING' });
	};

	return {
		init,
		refreshApp,
		doesUpdateExist,
	};
};
